import http from "../http";

export default {
  updateEdition(edition) {
    console.log({ edition });
    return http.plainAxiosInstance.put(`/editions/${edition.id}`, {
      edition: {
        winners_attributes: edition.winners_attributes,
      },
    });
  },
};
